import * as React from 'react'

import { useLocalization } from '../../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { intlPrettyCurrency } from '../../../../../../lib/utils'
import { BadgesSection } from '../../../ProductPage/ProductHighlights/BadgesSection'

import {
  BadgesSectionContainer,
  Container,
  Description,
  OriginalPrice,
  Price,
  SiteWidePromoWrap,
  Title,
} from './styles'

export interface KitHighlightsProps {
  title: string | undefined
  description: string | undefined
  discountPrice?: number | null
  discountPriceExplicitFmt?: string | null
  price: number
  priceExplicitFmt?: string | null
  badges: ReadonlyArray<string> | undefined
  siteWidePromo: string | null
  swPromoEligible: boolean | undefined
}

export const KitHighlights: React.FC<KitHighlightsProps> = ({
  title,
  badges,
  description,
  discountPriceExplicitFmt,
  price,
  priceExplicitFmt,
  discountPrice,
  siteWidePromo,
  swPromoEligible,
}) => {
  const { locale, region } = useLocalization()

  const {
    collections: {
      productGroupTile: { valueSignalLabel },
    },
  } = useTranslation()

  const formattedPrice =
    priceExplicitFmt ??
    intlPrettyCurrency({ unit: 'cents', value: price, region: region, locale: locale })

  return (
    <Container data-testid='kit-highlights'>
      <Title asTag='h1'>{title}</Title>
      <Price>
        {!!discountPrice
          ? discountPriceExplicitFmt ??
            intlPrettyCurrency({
              unit: 'cents',
              value: discountPrice,
              region: region,
              locale: locale,
            })
          : formattedPrice}
        {!!discountPrice && (
          <OriginalPrice>
            ({formattedPrice} {valueSignalLabel})
          </OriginalPrice>
        )}
      </Price>
      {badges && badges.length > 0 && (
        <BadgesSectionContainer>
          <BadgesSection badges={badges} />
        </BadgesSectionContainer>
      )}
      {siteWidePromo && swPromoEligible && <SiteWidePromoWrap>{siteWidePromo}</SiteWidePromoWrap>}
      <Description asTag='p'>{description}</Description>
    </Container>
  )
}

export default KitHighlights
